export default "__VITE_ASSET__C_lnJH3S__"